import React, { useState } from 'react';
import Modal from 'react-modal';
import { MdClose } from 'react-icons/md';
import {
  courseColor,
  graduateCoursesData,
  undergraduateCoursesData,
} from './constants';
import { filterProjectsByCourseName } from './constants';
import Projects from '../components/Projects';

const Subject = (props) => {
  const { educationType } = props;

  const courses =
    educationType === 'undergraduate'
      ? undergraduateCoursesData
      : graduateCoursesData;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState('');
  const [selectedTechSkills, setSelectedTechSkills] = useState('');
  const [selectedProjects, setSelectedProjects] = useState('');

  const handleCourseClick = (
    courseName,
    techSkills,
    projectTitle = '',
    projectDescription = ''
  ) => {
    setSelectedCourse(courseName);
    setSelectedTechSkills(techSkills);

    setSelectedProjects(filterProjectsByCourseName(courseName));

    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <div style={styles.coursesColumn}>
        {courses.map((course, index) => (
          <div
            key={index}
            style={styles.courseButton}
            onClick={() =>
              handleCourseClick(course.courseName, course.techSkills)
            }
          >
            {course.courseName}
          </div>
        ))}
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        style={styles.modalStyles}
      >
        <div style={styles.modalHeader}>
          <h2>{selectedCourse}</h2>
          <button style={styles.closeButton} onClick={handleCloseModal}>
            <MdClose size={24} />
          </button>
        </div>
        <h3>Tech Skills</h3>
        <p>{selectedTechSkills}</p>

        {selectedProjects && selectedProjects.length > 0 && (
          <Projects projects={selectedProjects} />
        )}

        {/* writing just below check, wont be sufficient for empty arrays.
        {selectedProjectTitle && ( - If selectedProjectTitle exists (i.e., not an empty string or null)
          our case gets empty array, so will enter. so length check needed
         */}
      </Modal>
    </div>
  );
};

const styles = {
  coursesColumn: {
    display: 'flex',
    // flexDirection: 'column',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center', // Center horizontally
    alignItems: 'center', // Center vertically
    gap: '5px',
    // border: '1px solid red',
  },
  courseButton: {
    display: 'inline-block',
    padding: '10px',
    borderRadius: '10px',
    background: courseColor,
    cursor: 'pointer',
  },
  modalStyles: {
    content: {
      maxWidth: '800px',
      margin: 'auto',
      overflow: 'auto',
      maxHeight: '50vh', //viewport height
    },
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '0',
    marginLeft: '10px',
  },
};

export default Subject;
